/**
 * The ScrollToHash component
 */
import { useEffect } from "react";
import { isServer } from "../../../redux/store";

/**
 * React component to scroll to the hash when route has a hash
 */
export default function ScrollToId({ id }) {
  useEffect(() => {
    if (!isServer && id) {
      const el = document.getElementById(`${id}`);
      const scrollOptions = {
        behavior: "auto",
      };
      if (el) el.scrollIntoView(scrollOptions);
    }
  }, [id]);

  return null;
}
